import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib';

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  includeInactive: false,
  queryKey: ['framework-agreement-suppliers'],
  queryOptions: {},
};

const getConsortiumGroupSupplierCount = async (faId, cgId) =>
  axios.get(`/api/framework_agreements/${faId}/consortium_groups/${cgId}/companies/count`);

const getFrameworkAgreementSuppliers = async (frameworkAgreementId, queryStringParams) => {
  const queryString = qs.stringify({ companytype: 'supplier', ...queryStringParams });

  const {
    data: { data, total },
  } = await axios.get(`/api/framework_agreements/${frameworkAgreementId}/suppliers?${queryString}`);
  // await axios.get(`/api/framework_agreements/${frameworkAgreementId}/companies?${queryString}`);

  const consortiumGroups = data.filter(({ company_type }) => company_type === 'group');
  const counts = await Promise.all(
    consortiumGroups.map(({ ConsortiumGroup: { cg_id } }) =>
      getConsortiumGroupSupplierCount(frameworkAgreementId, cg_id)
    )
  );

  counts.forEach(({ data: { count } }, index) => {
    const cgId = consortiumGroups[index].cg_id;

    const supplierIndex = data.findIndex(({ cg_id }) => cg_id === cgId);

    data[supplierIndex].ConsortiumGroup.supplierCount = count;
  });

  return { suppliers: data, total };
};

export const useFrameworkAgreementSuppliers = (frameworkAgreementId, queryParams = {}) => {
  const { page, limit, search, includeInactive, queryKey, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    search,
    includeinactive: includeInactive,
    offset: page * limit,
  };

  return useQuery(
    [...queryKey, frameworkAgreementId],
    () => getFrameworkAgreementSuppliers(frameworkAgreementId, queryStringParams),
    {
      select: ({ suppliers, total }) => ({ suppliers, total }),
      initialData: { suppliers: [], total: 0 },
      ...queryOptions,
    }
  );
};
